export default __webpack_public_path__ + "static/media/nutritionGuideScreenshot2.86d397ff.png";